// Static catalog of Lovable AI Gateway chat models. The gateway is
// allowlist-only: sending an unknown model id returns HTTP 400, so a
// live fetch is inappropriate. Keep this list in sync with the
// `ai-models-chat` knowledge doc.

export type LovableAiModel = {
  id: string;           // e.g. "openai/gpt-5.5"
  name: string;         // human label
  provider: "Google" | "OpenAI";
  contextLength?: number;
};

export const LOVABLE_AI_MODELS: LovableAiModel[] = [
  // Google
  { id: "google/gemini-3-flash-preview",   name: "Gemini 3 Flash (preview)", provider: "Google" },
  { id: "google/gemini-3.1-flash-lite",    name: "Gemini 3.1 Flash Lite",    provider: "Google" },
  { id: "google/gemini-3.5-flash",         name: "Gemini 3.5 Flash",         provider: "Google" },
  { id: "google/gemini-3.1-pro-preview",   name: "Gemini 3.1 Pro (preview)", provider: "Google" },
  { id: "google/gemini-2.5-pro",           name: "Gemini 2.5 Pro",           provider: "Google" },
  { id: "google/gemini-2.5-flash",         name: "Gemini 2.5 Flash",         provider: "Google" },
  { id: "google/gemini-2.5-flash-lite",    name: "Gemini 2.5 Flash Lite",    provider: "Google" },

  // OpenAI
  { id: "openai/gpt-5",       name: "GPT-5",        provider: "OpenAI" },
  { id: "openai/gpt-5-mini",  name: "GPT-5 Mini",   provider: "OpenAI" },
  { id: "openai/gpt-5-nano",  name: "GPT-5 Nano",   provider: "OpenAI" },
  { id: "openai/gpt-5.2",     name: "GPT-5.2",      provider: "OpenAI" },
  { id: "openai/gpt-5.4",     name: "GPT-5.4",      provider: "OpenAI" },
  { id: "openai/gpt-5.4-mini",name: "GPT-5.4 Mini", provider: "OpenAI" },
  { id: "openai/gpt-5.4-nano",name: "GPT-5.4 Nano", provider: "OpenAI" },
  { id: "openai/gpt-5.5",     name: "GPT-5.5",      provider: "OpenAI" },
];

export const LOVABLE_AI_PROVIDER_ORDER: LovableAiModel["provider"][] = ["Google", "OpenAI"];
